
const textFilter = function(text) {
  return text || '--'
}
export default textFilter
